import React from 'react';

const HelpButton = () => {

  const getHelpUrl = () => {
    let helpUrl = "https://stephenfiumara.notion.site/Quote-Help-Center-dc847db12aa346a8aac364ae80f3e692";
    switch (true) {
      // case window.location.href.includes("3243"):
      //   return "";
      default:
        return helpUrl
    }
  };

  const openHelpPage = () => {
    window.open(getHelpUrl(), "_blank");
  };

  return (
    <div className="central-hub-help-icon" onClick={openHelpPage}>
      <div className="central-hub-icon-desc">Help</div>
    </div>
  )
};


export default HelpButton
